<div class="op-main-menu">
  <ul>
    @for (item of sections; track item.id) {
      <li [opMenuItem]="item" [menuAccordionMode]="menuAccordionMode" [submenuFixed]="menuFixedFirstLevel"></li>
    }
  </ul>
</div>
